import { useState } from 'react'
import { FormHelperText, Grid, TextField, Typography } from "@mui/material";
import ButtonComponent from "../shared/button/button.component";
import { ToasterTexts, appNote, buttonLabels, } from "../shared/constants";
import CustomSwitch from '../shared/switch.component';
import SettingsHeader from './settingsHeader.component';
import { AppRoutes } from '../routes/route.path';
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { ChannelUserService } from '../../services/ChannelUserService';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';


const Signature = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const CurrentUser = ChannelUserService.getCurrentUserFromLocalStorage();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [signAll, setSignAll] = useState<boolean>(CurrentUser.Signature.IsEnabledSign);
    const [signError, setSignError] = useState<string>("");
    const [signature, setSignature] = useState(CurrentUser.Signature.Value);



    const formSubmit = async (e: any) => {
        e.preventDefault();
        if (!signError) {
            let data = {
                "value": signature,
                "is_enable_sign": signAll
            }
            setIsLoading(true)
            ChannelUserService.updateUserSignature(CurrentUser.ID, data).then(() => {
                ChannelUserService.getCurrentUser(CurrentUser.Email).then((res) => {
                    setIsLoading(false)
                    navigate(AppRoutes.SETTINGS)
                })
                setToast(ToasterTexts.CUSTOM_SIGNATURE, ToasterType.SUCCESS)
            }).catch(() => {
                setIsLoading(false)
            })
        }
    }

    const handleSwitch = (checked: boolean) => {
        setSignAll(checked)
    }

    const handleChange = (e: any) => {
        setSignature(e.target.value)
        if (e.target.value.length > 30) {
            setSignError("Custom Signature should not exceed 30 characters")
        }
        else if (!e.target.value.trim() || e.target.value.trim().length <= 0) {
            setSignError("Custom Signature cannot be blank")
        }
        else {
            setSignError("")
        }
    };
    return (
        <>
            <div className="w-p-96 h-4 d-flex justify-between mx-auto">
                <div className="h5-regular settings-nav-bar-option">
                    {appNote.AUTOMATICALLY_APPEND_SIGNATURE}
                </div>
                <div className="p-relative b-2">
                    <CustomSwitch
                        checked={signAll}
                        onChange={(checked: boolean) => handleSwitch(checked)}
                    />
                </div>
            </div>
            <div className='w-p-96 min-h-6 d-flex justify-between align-center mt-3'>
                <form onSubmit={formSubmit} className='d-flex flex-direction w-p-100'>
                    <TextField
                        autoFocus
                        placeholder="Custom Signature "
                        variant="outlined"
                        size="small"
                        name="Custom Signature"
                        fullWidth
                        value={signature}
                        className="br-1 w-fill"
                        onChange={(e) => handleChange(e)}
                    />
                    <FormHelperText className="h5 color-primary-danger ml-auto">
                        {signError}
                    </FormHelperText>
                </form>
            </div>
            <div className='w-p-96 min-h-6 d-flex justify-flex-end align-center mt-1'>
                <ButtonComponent
                    Variant="primary-btn-small"
                    ClassName={`c-pointer w-space`}
                    OnClick={formSubmit}
                    ButtonLabel={buttonLabels.SAVE}
                    Loading={isLoading}
                />
            </div>
        </>
        // <Grid container className={`${IsMobileDevice ? 'paper-background' : 'bg-color-settings-background'} h-p-95  m-auto o-y-scroll`}>
        //     <div className={`${IsMobileDevice ? "w-p-100" : 'w-p-60 settings-paper-border br-2 m-auto paper-background'} `}>
        //         <SettingsHeader IsMobileDevice={IsMobileDevice} Title={"Custom Signature"} />
        //         <div>
        //             <form onSubmit={formSubmit}>
        //                 {<Grid container className="px-3 pb-2">
        //                     <Typography className=" my-3 color-signature-title h4-regular">
        //                         {appNote.EDIT_CUSTOM_SIGNATURE}
        //                     </Typography>
        //                     <TextField
        //                         autoFocus
        //                         placeholder="Custom Signature "
        //                         label="Custom Signature"
        //                         variant="outlined"
        //                         size="small"
        //                         name="Custom Signature"
        //                         fullWidth
        //                         value={signature}
        //                         className="br-1 w-fill"
        //                         onChange={(e) => handleChange(e)}
        //                     />
        //                     <FormHelperText className="h5 color-primary-danger ml-auto">
        //                         {signError}
        //                     </FormHelperText>
        //                 </Grid>}
        //             </form>
        //             <Grid container className="px-3 pb-3">
        //                 <Grid item className="t-align-left d-flex  py-1 my-auto">
        //                     <Typography className=" h5-regular color-signature-text-font t-align-left">
        //                         {appNote.AUTOMATICALLY_APPEND_SIGNATURE}
        //                     </Typography>
        //                 </Grid>
        //                 <Grid item className="b-none my-auto ml-auto" >
        //                     <CustomSwitch
        //                         checked={signAll}
        //                         onChange={(checked: boolean) => handleSwitch(checked)}
        //                     />
        //                 </Grid>

        //                 <Grid item xs={12} className="d-flex mt-2 justify-flex-end" >
        //                     <ButtonComponent
        //                         Variant="primary-btn-small"
        //                         ClassName={`c-pointer w-space mr-1`}
        //                         OnClick={formSubmit}
        //                         ButtonLabel={buttonLabels.SAVE}
        //                         Loading={isLoading}
        //                     />
        //                     <ButtonComponent
        //                         Variant="secondary-btn-small"
        //                         ClassName={`c-pointer`}
        //                         OnClick={() => navigate(AppRoutes.SETTINGS)}
        //                         ButtonLabel={buttonLabels.CANCEL}
        //                     />
        //                 </Grid>
        //             </Grid>
        //         </div>
        //     </div>
        // </Grid>
    )
}

export default Signature;